import {FlowContextStore} from '../stores';
import {LoginRequestService} from '../services/login-request.service';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard que protege rutas requiriendo autenticación
 * Si no hay sesión, muestra un aviso sobre el wall público y conserva el destino.
 */
export const authGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const returnUrl = state.url;

  if (authService.isAuthenticated()) {
    return true;
  }

  const companyId = Number(_route.queryParams['companyId']);
  const queryParams = {companyId:Number.isSafeInteger(companyId) && companyId > 0 ? companyId : inject(FlowContextStore).companyId() || 1};
  inject(LoginRequestService).request(returnUrl, queryParams);
  // Direct protected URLs display the public wall behind the login notice.
  return router.createUrlTree(['/promotions'], {queryParams});
};
